import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { bool, func, node, number, oneOfType, string } from 'prop-types';
import { Container, Input } from './checkbox.styles';
const Checkbox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    checked,
    defaultChecked,
    disabled,
    value,
    onChange,
    label,
    name,
    as
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "checked", "defaultChecked", "disabled", "value", "onChange", "label", "name", "as"]);

  const input = /*#__PURE__*/React.createElement(Input, {
    onChange: e => onChange(e, value),
    checked: checked,
    disabled: disabled,
    defaultChecked: defaultChecked,
    ref: ref,
    value: value,
    name: name,
    "data-testid": "checkbox-item"
  });
  return children || label ? /*#__PURE__*/React.createElement(Container, _extends({
    forwardedAs: as,
    disabled: disabled
  }, props, {
    "data-testid": "checkbox"
  }), input, label || children) : input;
});
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  /**
   * The content of the component,
   */
  children: node,

  /**
   * The text of the associated label element.
   */
  label: string,

  /**
   * Whether or not checkbox is checked.
   */
  checked: bool,

  /**
   * The initial value of checked.
   */
  defaultChecked: bool,

  /**
   * A checkbox can appear disabled and be unable to change states
   * @default false
   */
  disabled: bool,

  /**
   * The HTML input value.
   */
  value: oneOfType([string, number]),

  /**
   * The HTML input name.
   */
  name: oneOfType([string, number]),

  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {value} - value attribute.
   */
  onChange: func,

  /**
   * Gap between checkbox and label
   * @default 2
   */
  gap: number,

  /**
   * Switch tag html rendered
   * @default 'label'
   */
  as: string
} : void 0;
Checkbox.defaultProps = {
  children: null,
  disabled: false,
  color: 'text.base',
  as: 'label',
  gap: 2,
  onChange: () => {}
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;